<template>
  <button
    @click="$emit('click')"
    :disabled="disabled"
    :class="[
      'rounded-md cursor-pointer',
      padding,
      theme,
      { disabled: disabled, 'w-full': stretch }
    ]"
  >
    <Text v-if="!showSpinner" :size="size" :inline="true">
      <slot />
    </Text>
    <div v-else class="flex">
      <Text :size="size" :inline="true">
        <slot />
      </Text>
      <LoadingSpinner class="ml-2" />
    </div>
  </button>
</template>
<script setup>
import { computed } from "vue"
import Text from "../components/Text.vue"
import LoadingSpinner from "../components/LoadingSpinner.vue"

defineEmits(["click"])

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  size: {
    type: String,
    default: "md"
  },
  theme: {
    type: String,
    default: "basic"
  },
  stretch: {
    type: Boolean,
    default: false
  },
  showSpinner: {
    type: Boolean,
    default: false
  }
  // todo
  // filled: {
  //   type: Boolean,
  //   default: false
  // }
})

const padding = computed(() => {
  return {
    xs: "p-1 pl-1.5 pr-1.5",
    sm: "p-1.5 pl-2 pr-2",
    md: "p-2 pl-2.5 pr-2.5",
    lg: "p-2.5",
    xl: "p-3",
    "2xl": "p-3.5",
    "3xl": "4"
  }[props.size]
})

const theme = computed(() => {
  return `${props.theme} ${props.filled ? "filled" : ""} ${
    {
      basic: "border-gray bg-white",
      primary: "border-primary weight-600 text-maroon",
      secondary: "border-secondary weight-600 text-secondary",
      tertiary: "bg-green-1 border-green-1 text-green-1"
    }[props.theme]
  }`
})
</script>
<style scoped>
.basic {
  background: white;
}
.basic:hover {
  background: rgba(249, 250, 251);
}

.basic:disabled {
  background: white;
}

.primary {
  background: rgb(255, 248, 248);
}

.primary:hover {
  background: rgb(255, 235, 235);
}

.primary:disabled {
  background: rgb(255, 246, 246);
}

.secondary {
  background: rgb(250, 251, 255);
}

.secondary:hover {
  background: rgb(241, 247, 255);
}

.secondary:disabled {
  background: rgb(255, 246, 246);
}

.tertiary:hover {
  background: rgb(66, 170, 70);
}
</style>
